var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',{staticClass:"text-h5 mb-6"},[_c('v-col',[_vm._v(" "+_vm._s(_vm.$t('preferences.title'))+" ")])],1),_c('PreferencesSettings'),_c('v-row',[_c('v-col',[_c('v-divider')],1)],1),_c('CalendarSharingSettings')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }